export default __webpack_public_path__ + "static/media/person-1.7d929fef.png";